import React from "react";
import { languages } from "../../constants/languages";
import { getPouleScores } from "../../util/GetPouleScores";
import { countDecimals } from "../../util/CountDecimals";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { getGameResults } from "../../util/GetGameResults";
import InfoIcon from "@material-ui/icons/Info";
import { Typography } from "@material-ui/core";

const styles = {
  rankCell: {
    paddingRight: 5,
  },
  numCell: {
    textAlign: "center",
    padding: "6px 10px 6px 10px",
  },
};

export default class PouleTable extends React.Component {
  handleMinus = (teamId) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const pouleRef = tournamentRef
      .collection("poules")
      .doc(this.props.selectedPoule);
    let poule = this.props.poulesByKey[this.props.selectedPoule] || {};
    let minusPoints = poule.minusPoints || {};
    minusPoints[teamId] = (minusPoints[teamId] || 0) - 1;
    pouleRef.update({ minusPoints: minusPoints });
  };

  handlePlus = (teamId) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const pouleRef = tournamentRef
      .collection("poules")
      .doc(this.props.selectedPoule);
    let poule = this.props.poulesByKey[this.props.selectedPoule] || {};
    let plusPoints = poule.plusPoints || {};
    plusPoints[teamId] = (plusPoints[teamId] || 0) + 1;
    pouleRef.update({ plusPoints: plusPoints });
  };

  render() {
    let poule = this.props.poulesByKey[this.props.selectedPoule] || {};
    let minusPoints = poule.minusPoints || {};
    let plusPoints = poule.plusPoints || {};
    let pouleResults = getPouleScores(
      this.props.tournament,
      this.props.matches.filter(
        (match) => match.poule === this.props.selectedPoule
      ),
      poule
    );

    let scoreType =
      poule.scoreType ||
      (poule.bracket
        ? (this.props.tournament.scoringTypesPerBracket || {})[poule.bracket] ||
          {}
        : false) ||
      ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
        poule.division
      ] || {})[poule.fase] ||
      "default";
    let scoring =
      scoreType === "default"
        ? this.props.tournament
        : (this.props.tournament.scoringTypes || {})[scoreType] ||
          this.props.tournament;

    const useSets = (scoring.useSets || "0") === "1";

    if (this.props.pouleResults) {
      pouleResults = this.props.pouleResults;
    }
    pouleResults = pouleResults.filter((r) => {
      let hide = false;
      if (poule["status" + r.teamKey]) {
        hide = true;
      }
      return !hide;
    });
    let teams = {};
    this.props.teams
      .filter((t) => {
        return t["poule" + poule.fase] === this.props.selectedPoule;
      })
      .forEach((t) => {
        teams[t["numInPoule" + poule.fase]] = t;
      });

    let pouleFinished = true;
    this.props.matches
      .filter(
        (match) =>
          match.poule === this.props.selectedPoule &&
          poule["status" + match.team1] !== "noShow" &&
          poule["status" + match.team2] !== "noShow"
      )
      .forEach((match) => {
        let finished = true;
        if (useSets) {
          let gameResults = getGameResults(scoring, match.sets || {});
          finished = gameResults.finished;
        } else {
          finished = match.score1 !== null && match.score2 !== null;
        }
        if (!finished) {
          pouleFinished = false;
        }
      });

    const undeterminedMessages = [];
    if (pouleFinished) {
      let d = [];
      pouleResults.forEach((pR) => {
        if (pR.undetermined && d.indexOf(pR.undetermined) === -1) {
          const namesForMessage = pouleResults
            .filter((p) => p.undetermined === pR.undetermined)
            .map((p) => "'" + teams[p.teamKey].name + "'");
          const message = languages.formatString(
            languages.tiebreakers.undeterminedMessage,
            this.props.tournament.individualPlayers
              ? languages.teams.playersLow
              : languages.tournament.teamsLow,
            namesForMessage.join(" " + languages.general.and + " ")
          );
          undeterminedMessages.push(message);
          d.push(pR.undetermined);
        }
      });
    }

    return (
      <>
        <Table size="small" style={{ marginTop: 15 }}>
          <TableHead>
            <TableRow style={{ height: 20 }}>
              <TableCell style={styles.rankCell}>#</TableCell>
              <TableCell>{languages.general.name}</TableCell>
              <TableCell style={styles.numCell}>
                {languages.results.pouleResults.played}
              </TableCell>
              <TableCell style={styles.numCell}>
                {languages.results.pouleResults.won}
              </TableCell>
              <TableCell style={styles.numCell}>
                {languages.results.pouleResults.tie}
              </TableCell>
              <TableCell style={styles.numCell}>
                {languages.results.pouleResults.loss}
              </TableCell>
              <TableCell style={styles.numCell}>
                <b>{languages.results.pouleResults.points}</b>
              </TableCell>
              {useSets && (
                <>
                  <TableCell style={styles.numCell}>
                    {languages.results.pouleResults.setsFor}
                  </TableCell>
                  <TableCell style={styles.numCell}>
                    {languages.results.pouleResults.setsAgainst}
                  </TableCell>
                  <TableCell style={styles.numCell}>
                    {languages.results.pouleResults.setsDifference}
                  </TableCell>
                </>
              )}
              <TableCell style={styles.numCell}>
                {this.props.tournament.standingsTableWithPoints
                  ? languages.results.pouleResults.pointsFor
                  : languages.results.pouleResults.goalsFor}
              </TableCell>
              <TableCell style={styles.numCell}>
                {this.props.tournament.standingsTableWithPoints
                  ? languages.results.pouleResults.pointsAgainst
                  : languages.results.pouleResults.goalsAgainst}
              </TableCell>
              <TableCell style={styles.numCell}>
                {this.props.tournament.standingsTableWithPoints
                  ? languages.results.pouleResults.pointsDifference
                  : languages.results.pouleResults.goals}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pouleResults.map((results, i) => {
              let team = teams[results.teamKey] || {};
              let mp = minusPoints[results.teamKey] || 0;
              let pp = plusPoints[results.teamKey] || 0;
              let total = mp + pp;

              let toFixed = 0;
              let numDecimals = countDecimals(results.pouleScore);
              if (numDecimals > 1) {
                toFixed = 1;
              } else {
                toFixed = numDecimals;
              }
              let toFixedGoals = 0;
              let numDecimalsGoals = countDecimals(results.goals);
              if (numDecimalsGoals > 1) {
                toFixedGoals = 1;
              } else {
                toFixedGoals = numDecimalsGoals;
              }
              let toFixedSets = 0;
              let numDecimalsSets = countDecimals(results.sets);
              if (numDecimalsSets > 1) {
                toFixedSets = 1;
              } else {
                toFixedSets = numDecimalsSets;
              }
              let toFixedSetsFor = 0;
              let numDecimalsSetsFor = countDecimals(results.setsFor);
              if (numDecimalsSetsFor > 1) {
                toFixedSetsFor = 1;
              } else {
                toFixedSetsFor = numDecimalsSetsFor;
              }
              let toFixedSetsAgainst = 0;
              let numDecimalsSetsAgainst = countDecimals(results.setsAgainst);
              if (numDecimalsSetsAgainst > 1) {
                toFixedSetsAgainst = 1;
              } else {
                toFixedSetsAgainst = numDecimalsSetsAgainst;
              }
              let toFixedGoalsFor = 0;
              let numDecimalsGoalsFor = countDecimals(results.goalsFor);
              if (numDecimalsGoalsFor > 1) {
                toFixedGoalsFor = 1;
              } else {
                toFixedGoalsFor = numDecimalsGoalsFor;
              }
              let toFixedGoalsAgainst = 0;
              let numDecimalsGoalsAgainst = countDecimals(results.goalsAgainst);
              if (numDecimalsGoalsAgainst > 1) {
                toFixedGoalsAgainst = 1;
              } else {
                toFixedGoalsAgainst = numDecimalsGoalsAgainst;
              }

              let undetermined =
                results.undetermined !== undefined && pouleFinished;

              return (
                <TableRow
                  key={this.props.selectedPoule + i}
                  style={{
                    height: 20,
                    borderLeft: undetermined ? "5px solid #d50000" : "",
                  }}
                >
                  <TableCell style={styles.rankCell}>{i + 1}</TableCell>
                  <TableCell
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: useSets ? 135 : 200,
                      maxWidth: useSets ? 135 : 200,
                      lineHeight: 1.7,
                    }}
                  >
                    {team.gamertag || team.name || ""}
                  </TableCell>
                  <TableCell style={styles.numCell}>{results.played}</TableCell>
                  <TableCell style={styles.numCell}>{results.won}</TableCell>
                  <TableCell style={styles.numCell}>{results.tie}</TableCell>
                  <TableCell style={styles.numCell}>{results.loss}</TableCell>
                  <TableCell align="center" style={styles.numCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 80,
                      }}
                    >
                      <RemoveIcon
                        style={{
                          height: 20,
                          width: 20,
                          cursor: "pointer",
                          color: "gray",
                          marginRight: 2,
                        }}
                        onClick={() => {
                          this.handleMinus(results.teamKey);
                        }}
                      />
                      <b>
                        {results.pouleScore.toFixed(toFixed)}
                        {total !== 0 && (
                          <sup style={{ color: total > 0 ? "green" : "red" }}>
                            {" " + (total > 0 ? "+" : "") + total}
                          </sup>
                        )}
                      </b>
                      <AddIcon
                        style={{
                          height: 20,
                          width: 20,
                          cursor: "pointer",
                          color: "gray",
                          marginLeft: 2,
                        }}
                        onClick={() => {
                          this.handlePlus(results.teamKey);
                        }}
                      />
                    </div>
                  </TableCell>

                  {useSets && (
                    <>
                      <TableCell style={styles.numCell}>
                        {results.setsFor.toFixed(toFixedSetsFor)}
                      </TableCell>
                      <TableCell style={styles.numCell}>
                        {results.setsAgainst.toFixed(toFixedSetsAgainst)}
                      </TableCell>
                      <TableCell style={styles.numCell}>
                        {results.sets.toFixed(toFixedSets)}
                      </TableCell>
                    </>
                  )}
                  <TableCell style={styles.numCell}>
                    {results.goalsFor.toFixed(toFixedGoalsFor)}
                  </TableCell>
                  <TableCell style={styles.numCell}>
                    {results.goalsAgainst.toFixed(toFixedGoalsAgainst)}
                  </TableCell>
                  <TableCell style={styles.numCell}>
                    {results.goals.toFixed(toFixedGoals)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {undeterminedMessages.map((message, i) => (
          <div
            key={i}
            style={{
              padding: 10,
              background: "rgb(236, 239, 241)",
              display: "flex",
            }}
          >
            <InfoIcon
              style={{ height: 20, width: 20, marginRight: 7 }}
              color="secondary"
            />
            <Typography variant="body2" style={{ whiteSpace: "normal" }}>
              {message}
            </Typography>
          </div>
        ))}
      </>
    );
  }
}
